import { Controller } from "@hotwired/stimulus";

/**
 * Shows the placeholder again when the content loads again, so that the old
 * content is not visible until the new content arrives.
 */
export default class LazyLoadController extends Controller<HTMLElement> {
  static override values = { placeholder: String };
  declare readonly placeholderValue: string;

  reset(event: Event): void {
    // Requests from forms in the content send the same event.
    if (event.target !== this.element) return;
    this.element.innerHTML = this.placeholderValue;
  }
}
